import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import ProviderPageLayout from '../../components/ProviderPageLayout';
import { useAuth } from '../../auth/useAuth';

const ProviderForgot = () => {
  const [username, setUsername] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const { forgotPassword } = useAuth();

  useEffect(() => {
    if (location.state?.email) setUsername(location.state.email);
  }, [location.state?.email]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      await forgotPassword(username);
      setSuccess('Reset code sent. Check your email.');
      sessionStorage.setItem('resetUsername', username);
      setTimeout(() => navigate('/provider/reset'), 1800);
    } catch (err) {
      if (err.code === 'UserNotFoundException') {
        setError('No account found with that email.');
      } else if (err.code === 'LimitExceededException') {
        setError('Too many attempts. Try again later.');
      } else {
        setError(err.message || 'Something went wrong.');
      }
      setLoading(false);
    }
  };

  return (
    <ProviderPageLayout
      variant="split"
      splitImage="/images/gallery-bar.png"
      splitEyebrow="Account recovery"
      splitQuote="Locked out happens. We'll have you back to your dashboard in a moment."
    >
      <div className="provider-card provider-card--auth">
        <p className="provider-eyebrow">Account recovery</p>
        <h1 className="provider-title">Reset password</h1>
        <p className="provider-subtitle">
          Enter your email and we&apos;ll send a reset code.
        </p>

        {location.state?.fromProfile && (
          <div className="provider-alert provider-alert--info">
            You were signed out to reset your password. Sign in again after setting a new one.
          </div>
        )}

        {error && <div className="provider-alert provider-alert--error">{error}</div>}
        {success && <div className="provider-alert provider-alert--success">{success}</div>}

        <form onSubmit={handleSubmit}>
          <div className="provider-form-group">
            <label htmlFor="username" className="provider-label">Email</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              className="provider-input"
              placeholder="you@company.com"
              autoComplete="username"
            />
          </div>
          <button type="submit" disabled={loading} className="provider-btn provider-btn--primary">
            {loading ? 'Sending…' : 'Send reset code'}
          </button>
        </form>

        <div className="provider-footer-links">
          <button type="button" className="provider-link" onClick={() => navigate('/provider/login')}>
            Back to sign in
          </button>
        </div>
      </div>
    </ProviderPageLayout>
  );
};

export default ProviderForgot;
